import { Button, Col, Form, Input, Row, Space, theme, Table, message, Popconfirm } from 'antd';
import React, { useEffect, useState } from 'react';
import LoadingBase from '../../components/LoadingBase';
import '../../css/listbook-page.css';
import ModalAddAndEdit from './component/ModalAddAndEdit';
import { addNewDepartment, addNewSuppiler, getListDepartment, getListSuppiler, updateDepartmentById, updateSuppiler } from '../../services/apis';
import { TYPE_MODAL } from '../../constants/constants';
import { pad } from 'lodash';
import { BASE_URL } from '../../settings/config';

const ListSuppilerPage = () => {
    const { token } = theme.useToken();
    const [form] = Form.useForm();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [itemSelected, setItemSelected] = useState();
    const [typeModal, setTypeModal] = useState();
    const [titleModal, setTitleModal] = useState('');
    const columns = [
        {
            title: 'STT',
            key: 'STT',
            width: 80,
            align: 'center',
            render: (text, record, index) => index + 1,
        },
        {
            title: 'Tên nhà cung cấp',
            dataIndex: 'name',
            key: 'name',
            render: (text, record, index) => <a onClick={() => handleEditSuppiler(record)} style={{paddingLeft: 12}}>{text}</a>,
        },
        {
            title: 'File template',
            dataIndex: 'template_url',
            key: 'template_url',
            render: (text, record, index) => <span style={{paddingLeft: 12}}><a style={{color: 'red', textDecoration: 'underline'}} href={BASE_URL + text} target='_blank'>Link file template</a></span>,
        },
        {
            title: 'Số điện thoại',
            dataIndex: 'phone',
            key: 'phone',
            render: (text, record, index) => <span style={{paddingLeft: 12}}>{text}</span>,
        },
        {
            title: 'Địa chỉ',
            dataIndex: 'address',
            key: 'address',
            render: (text, record, index) => <span style={{paddingLeft: 12}}>{text}</span>,
        },
        {
            title: 'Hành động',
            dataIndex: 'action',
            key: 'action',
            width: 120,
            align: 'center',
            render: (text, record) => (
                <Space size="middle">
                    <a onClick={() => handleEditSuppiler(record)} >Sửa</a>
                </Space>
            ),
        },
    ];

    const formStyle = {
        maxWidth: 'none',
        background: 'white',
        borderRadius: token.borderRadiusLG,
        paddingLeft: 0,
        paddingRight: 0,
        marginBottom: 12,
    };
    
    const handleEditSuppiler = (record) => {
        setItemSelected(record);
        setTypeModal(TYPE_MODAL.EDIT);
        setShowModal(true);
        setTitleModal('Sửa nhà cung cấp');
    }
    const handleAddAccount = () => {
        setTypeModal(TYPE_MODAL.ADD);
        setShowModal(true);
        setTitleModal('Thêm nhà cung cấp');
    }
   
    const getDataSuppiler = async (showLoading) => {
        try {
            const params = {
                keyword: form.getFieldValue('name') ?? '',
            }
            if (showLoading) setLoading(true);
            const res = await getListSuppiler(params);
            if (showLoading) setLoading(false);
            if (res && res.status === 1) {
                setData([...res?.data]);
            } else {
                message.error(res.message);
                setData([]);
            }
        } catch (error) {
            setLoading(false);
            console.log('error', error);
        }
        

    }

    const onFinish = async (dataForm) => {
        getDataSuppiler(true);
    };
    const callApiAddSuppiler = async (data) => {
        try {
            setLoading(true);
            const res = await addNewSuppiler(data);  
            setLoading(false);
            if (res && res.status === 1) {
                message.success('Thêm mới thành công');
                getDataSuppiler(true);
            } else {
                message.error(res?.message ?? 'Có lỗi xảy ra');
            }          
        } catch (error) {
            console.log('error', error);
            setLoading(false);
        }
    }

    const callApiUpdateSuppiler = async (data) => {
        try {
            setLoading(true);
            const res = await updateSuppiler(data);
            setLoading(false);
            if (res && res.status === 1) {
                message.success('Cập nhật thành công');
                getDataSuppiler(true);
            } else {
                message.error(res?.message ?? 'Có lỗi xảy ra');
            }
        } catch (error) {
            console.log('error', error);
            setLoading(false);
        }
    }
    const handleOnSave = async (data) => {
        setShowModal(false);
        if (typeModal === TYPE_MODAL.ADD) {
            callApiAddSuppiler(data);
        } else {
            callApiUpdateSuppiler(data);
        }

    }

    useEffect(() => {
        getDataSuppiler(true)
    }, [])

    return (
        <div className='container-content'>

            <Form form={form} name="advanced_search" style={formStyle} onFinish={onFinish}>
                <Row gutter={24}>
                    <Col span={8}>
                        <Form.Item
                            name={'name'}
                        >
                            <Input placeholder={'Nhập tên'} />
                        </Form.Item>
                    </Col>


                    <Col span={4}>
                        <Space size="small">
                            <Button type="primary" htmlType="submit">
                                Tìm kiếm
                            </Button>
                            <Button danger onClick={handleAddAccount}>
                                Thêm mới
                            </Button>
                        </Space>
                    </Col>
                </Row>
            </Form>
            <Table
                className='table-book custom-table'
                columns={columns}
                dataSource={data}
                pagination={false}
                rowKey={(record) => record?.id}
                bordered
                rowClassName={() => 'custom-row'}
            />
            <LoadingBase loading={loading} />
            <ModalAddAndEdit
                visible={showModal}
                onCancel={() => setShowModal(false)}
                data={itemSelected}
                title={titleModal}
                onSave={handleOnSave}
                type={typeModal}
            />
            <LoadingBase loading={loading} />
        </div>
    )
}
export default React.memo(ListSuppilerPage);